/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./screen-split-prop.vue?vue&type=template&id=d9c041de&scoped=true&"
import script from "./screen-split-prop.vue?vue&type=script&lang=js&"
export * from "./screen-split-prop.vue?vue&type=script&lang=js&"
import style0 from "./screen-split-prop.vue?vue&type=style&index=0&id=d9c041de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c041de",
  null
  
)

export default component.exports